import React, { useCallback, useMemo } from 'react'
import truncate from 'lodash/truncate'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import { makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import OperationalTable, { useOperationalTable } from '../../../organisms/OperationalTable'
import { useClassificationTagTypes } from '../../../../api/coreData'
import { ADMIN_ROUTES } from '../../../../constants'
import {
  defaultSort,
  MAX_CHARACTERS,
  CHARACTER_SEPARATOR,
  assetCussipAccesor,
  cellTemplates
} from './helpers'
import { useClassifyAssets, useTotalClassifyAssets } from './hooks'

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '1rem'
  }
}))

function ClassifyAssets () {
  const history = useHistory()
  const {
    defaultPageSize,
    pageIndex,
    pageSize,
    sort,
    searchText,
    onPagingChange,
    onSortingChange,
    onTableModeChange,
    onSearchTextChange
  } = useOperationalTable(defaultSort)
  const classes = useStyles()

  const onClickRow = useCallback((row) => {
    if (row.original) {
      history.push(`${ADMIN_ROUTES.CLASSIFY_ASSETS}/${row.original.assetId}`)
    }
  }, [history])

  const { data: totalData } = useTotalClassifyAssets({ searchText })
  const { data: classificationTagsData, loading: classsificationTagLoading } = useClassificationTagTypes({ resultType: 'details' })
  const { data = [], loading } = useClassifyAssets({
    pageIndex,
    pageSize,
    sort,
    searchText
  })

  const { columns } = useMemo(() => {
    let columns = []
    if (!isEmpty(classificationTagsData) && !isEmpty(data)) {
      const subColumns = classificationTagsData.map((classificationTag, index) => ({
        Header: classificationTag.longName,
        accessor: (row) => {
          const classification = find(row.classificationTags, ['classificationTagTypeId', classificationTag.classificationTagTypeId])
          return truncate(classification?.longName, { length: MAX_CHARACTERS, separator: CHARACTER_SEPARATOR })
        },
        id: classificationTag.classificationType,
        disableSortBy: true
      }))
      columns = [
        { Header: 'Symbol', accessor: 'symbol', id: 'symbol' },
        { Header: 'CUSIP', accessor: 'cusip', id: 'cusip', Cell: cellTemplates.drilldownLink(assetCussipAccesor) },
        { Header: 'Asset Name', accessor: (row) => truncate(row.assetName || 'No Name Available', { length: MAX_CHARACTERS, separator: CHARACTER_SEPARATOR }), id: 'longName' },
        ...subColumns
      ]
    }
    return { columns }
  }, [data, classificationTagsData])

  return (
    <div className={classes.container}>
      <OperationalTable.Wrapper>
        <OperationalTable.SuperHeader className={classes.headspace}>
          <OperationalTable.Search
            onChange={onSearchTextChange}
            placeholder='Search'
            delay={250}
          />
        </OperationalTable.SuperHeader>
        <OperationalTable
          mode='server'
          columns={columns}
          data={data}
          defaultPageSize={defaultPageSize}
          defaultSort={defaultSort}
          itemName='Assets'
          loading={loading || classsificationTagLoading}
          total={totalData?.total}
          searchText={searchText}
          onSortingChange={onSortingChange}
          onPagingChange={onPagingChange}
          onTableModeChange={onTableModeChange}
          onRowClick={onClickRow}
        />
      </OperationalTable.Wrapper>
    </div>
  )
}

export default ClassifyAssets
